// TODO: Task 5404748: Consider what constant and helper functions from odsp-driver should be moved out to a new FF package that doesn't churn
export const OdcApiSiteOrigin = 'https://api.onedrive.com';
